import React from 'react';
import { Field } from 'redux-form';
import { getTranslatedString } from 'helpers/i18n';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import * as validator from 'helpers/Validator';
import * as format from 'helpers/Formatter';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

let LeadCardForm = (props) => {
  const { trafficSources, requireEmail, showNotes, minimumApplicantAge } = props;

  let require_email = [validator.validEmail];
  if (requireEmail) {
    require_email = [validator.required];
  }

  return (
    <div>
      <div className="row" style={{ marginTop: '20px' }}>
        <div className="col-sm-6">
          <Field
            name="first_name"
            component={TextField}
            label="First Name"
            variant="outlined"
            multiLine={false}
            fullWidth
            validate={[validator.required]}
          />
        </div>

        <div className="col-sm-6">
          <Field
            name="last_name"
            component={TextField}
            label="Last Name"
            variant="outlined"
            multiLine={false}
            fullWidth
            validate={[validator.required]}
          />
        </div>
      </div>

      <div className="row" style={{ marginTop: '20px' }}>
        <div className="col-sm-6">
          <Field
            name="email"
            type="email"
            component={TextField}
            label="Email"
            variant="outlined"
            multiLine={false}
            fullWidth
            validate={require_email}
          />
        </div>

        <div className="col-sm-6">
          <Field
            name="phone_number"
            type="text"
            label={getTranslatedString('landlordPortal.personalDetails.phoneNumber')}
            component={ReactPhoneInput}
            validate={[validator.required, validator.validInternationalPhoneNumber]}
            style={{ fontSize: '14px' }}
          />
        </div>
      </div>

      <div className="row" style={{ marginTop: '20px', marginBottom: '20px' }}>
        <div className="col-sm-6">
          <Field
            name="dob"
            label="Вirthday"
            component={DatePickerAccessible}
            variant="outlined"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            popperPlacement="top-end"
            maxDate={moment()
              .subtract(minimumApplicantAge || 18, 'years')
              .toDate()}
            openToYearSelection={true}
            formatDate={format.reformatDate}
            autoOk={true}
            textFieldStyle={{ width: '100%', fontSize: '14px' }}
            disableYearSelection={false}
          />
        </div>

        <div className="col-sm-6">
          <Field
            name="traffic_source"
            component={OutlinedSelect}
            validate={[validator.required]}
            label="Traffic Source"
            InputLabelProps={{ shrink: true }}
            fullWidth
          >
            {!isEmpty(trafficSources) &&
              trafficSources.map((source) => (
                <MenuItem key={`traffic_source_${source['id']}`} value={source['id']}>
                  {source['traffic_source']}
                </MenuItem>
              ))}
          </Field>
        </div>
      </div>

      {/* TODO: Figure out what to do with min and max budget */}
      {/* <div className="row">
        <div className="col-sm-6">
          <Field
            name="max_budget"
            component={TextField}
            floatingLabelText="Max Budget"
            multiLine={false}
            fullWidth
            validate={[validator.required, validator.greaterThanZero]}
            style={{ marginTop: '-15px', fontSize: '14px' }}
            {...format.currencyMask}
          />
        </div>
      </div> */}

      {showNotes && (
        <div className="row">
          <div
            className="col-xs-12"
            style={{ margin: 'auto', textAlign: 'initial', marginTop: '-15px' }}
          >
            <Field
              name="notes"
              component={TextField}
              style={{ fontSize: '14px' }}
              validate={[validator.required]}
              floatingLabelText="Notes"
              fullWidth
              multiLine
              rows={2}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadCardForm;
